import { render, staticRenderFns } from "./FilesHeaderNoteToRecipient.vue?vue&type=template&id=514f64d7&scoped=true"
import script from "./FilesHeaderNoteToRecipient.vue?vue&type=script&setup=true&lang=ts"
export * from "./FilesHeaderNoteToRecipient.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./FilesHeaderNoteToRecipient.vue?vue&type=style&index=0&id=514f64d7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "514f64d7",
  null
  
)

export default component.exports